import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./SidebareMobile.css";
import GetNotificationAdminNoRead from "../../../Services/Admin/GetNotificationAdminNoRead";
import { NotificationMagasinType } from "../../../Modeles/NotificationModel";
import AfficheProductsService from "../../../Services/Admin/AfficheProductsService";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import { MagasinInfo } from "../../../Modeles/MagasinModel";
import AfficheMagasinsService from "../../../Services/Magasin/AfficheMagasinsService";

interface NotificationType {
  Notifications: NotificationMagasinType[];
  messageErrosNotif: string;
}

interface ProductType {
  product: ArticleInfo[];
  messageErros: string;
}

interface ProductTypeMagasins {
  magasins: MagasinInfo[];
  messageErrosMagasin: string;
}

export default function SideBarMobile() {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState<string | null>("mobile");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [states, setStates] = useState<ProductTypeMagasins>({
    magasins: [],
    messageErrosMagasin: "Il n'y a pas de magasin",
  });
  const [search, setSearch] = useState("");
  const [alldata, setAlldata] = useState<ArticleInfo[]>([]);
  const [stateNotification, setStateNotification] = useState<NotificationType>({
    Notifications: [],
    messageErrosNotif: "aucune Notification",
  });
  const [state, setState] = useState<ProductType>({
    product: [],
    messageErros: "Il n'y a pas de produit",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location]);

  useEffect(() => {
    GetNotificationAdminNoRead()
      .GetNotification()
      .then((res) =>
        setStateNotification((prev) => ({ ...prev, Notifications: res.data }))
      )
      .catch(() => setStateNotification((prev) => ({ ...prev })));
  }, []);

  const toggleDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    // Implémentez votre logique de déconnexion ici
    console.log("Déconnexion...");
  };

  useEffect(() => {
    const handleClickOutside = () => {
      if (isDropdownOpen) setIsDropdownOpen(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isDropdownOpen]);

  return (
    <>
      <div className="bar-up">
        <div className="bar-yellow-empty"></div>
        <div className="name-w-iconleft">
          <h3>Wyn.ma</h3>
          <div className="icons-barup-sidebarmobile">
            <i className="bi bi-cart2"></i>
            <div style={{ position: "relative", display: "inline-block" }}>
              <i
                className="bi bi-three-dots-vertical"
                onClick={toggleDropdown}
                style={{
                  cursor: "pointer",
                  fontSize: "1.2rem",
                  padding: "0 10px",
                }}
              />

              {isDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "100%",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    zIndex: 1000,
                    minWidth: "180px",
                    padding: "8px 0",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Link
                    to="/Paramétres"
                    style={{
                      padding: "8px 16px",
                      color: "black",
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontSize: "14px",
                    }}
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    <svg width="20" height="20" viewBox="0 0 34 34" fill="none">
                      <path
                        d="M17 21.25C19.3472 21.25 21.25 19.3472 21.25 17C21.25 14.6528 19.3472 12.75 17 12.75C14.6528 12.75 12.75 14.6528 12.75 17C12.75 19.3472 14.6528 21.25 17 21.25Z"
                        stroke="black"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M5.18632 15.0733C5.85641 15.4926 6.28707 16.2094 6.28707 16.9999C6.28707 17.7904 5.85641 18.5073 5.18632 18.9266C4.73157 19.2142 4.43691 19.4423 4.22866 19.7143C4.00212 20.0095 3.83597 20.3466 3.73972 20.7061C3.64346 21.0656 3.61897 21.4405 3.66766 21.8095C3.74132 22.3677 4.07141 22.94 4.73016 24.0833C5.39174 25.2265 5.72182 25.7974 6.16807 26.1417C6.46336 26.3682 6.80038 26.5344 7.15989 26.6306C7.5194 26.7269 7.89435 26.7514 8.26332 26.7027C8.60332 26.6573 8.94757 26.5185 9.42357 26.2663C9.76435 26.0803 10.1467 25.9838 10.535 25.9857C10.9232 25.9877 11.3046 26.0882 11.6435 26.2777C12.3277 26.6743 12.7343 27.4039 12.7627 28.1944C12.7825 28.7328 12.8335 29.1011 12.9652 29.417C13.1076 29.761 13.3164 30.0736 13.5797 30.3368C13.8429 30.6001 14.1555 30.8089 14.4995 30.9513C15.0194 31.1666 15.6796 31.1666 16.9999 31.1666C18.3202 31.1666 18.9804 31.1666 19.5003 30.9513C19.8443 30.8089 20.1569 30.6001 20.4201 30.3368C20.6834 30.0736 20.8922 29.761 21.0346 29.417C21.1649 29.1011 21.2173 28.7328 21.2372 28.1944C21.2655 27.4039 21.6721 26.6729 22.3563 26.2777C22.6952 26.0882 23.0766 25.9877 23.4648 25.9857C23.8531 25.9838 24.2355 26.0803 24.5762 26.2663C25.0522 26.5185 25.3979 26.6573 25.7379 26.7027C26.4826 26.8006 27.2357 26.5988 27.8317 26.1417C28.278 25.7988 28.6081 25.2265 29.2682 24.0833C29.5629 23.5733 29.791 23.178 29.961 22.8465M28.8135 18.928C28.4821 18.7261 28.2073 18.4435 28.0148 18.1065C27.8223 17.7696 27.7184 17.3894 27.7127 17.0013C27.7127 16.2094 28.1434 15.4926 28.8135 15.0718C29.2682 14.7857 29.5615 14.5576 29.7712 14.2856C29.9977 13.9903 30.1638 13.6533 30.2601 13.2938C30.3564 12.9343 30.3808 12.5593 30.3322 12.1903C30.2585 11.6322 29.9284 11.0598 29.2697 9.91659C28.6081 8.77334 28.278 8.20242 27.8317 7.85817C27.5365 7.63163 27.1994 7.46549 26.8399 7.36923C26.4804 7.27297 26.1055 7.24849 25.7365 7.29717C25.3965 7.3425 25.0522 7.48134 24.5748 7.7335C24.2342 7.91929 23.8521 8.0157 23.4641 8.01371C23.0761 8.01173 22.695 7.91143 22.3563 7.72217C22.0229 7.5234 21.7453 7.2433 21.5496 6.90809C21.3539 6.57287 21.2464 6.19348 21.2372 5.80542C21.2173 5.26709 21.1663 4.89875 21.0346 4.58284C20.8922 4.23884 20.6834 3.92628 20.4201 3.66303C20.1569 3.39977 19.8443 3.19098 19.5003 3.04859C18.9804 2.83325 18.3202 2.83325 16.9999 2.83325C15.6796 2.83325 15.0194 2.83325 14.4995 3.04859C14.1555 3.19098 13.8429 3.39977 13.5797 3.66303C13.3164 3.92628 13.1076 4.23884 12.9652 4.58284C12.8349 4.89875 12.7825 5.26709 12.7627 5.80542C12.7534 6.19348 12.6459 6.57287 12.4502 6.90809C12.2545 7.2433 11.9769 7.5234 11.6435 7.72217C11.3046 7.91168 10.9232 8.01212 10.535 8.0141C10.1467 8.01609 9.76435 7.91954 9.42357 7.7335C8.94757 7.48134 8.60191 7.3425 8.26191 7.29717C7.51719 7.19924 6.76406 7.40102 6.16807 7.85817C5.72324 8.20242 5.39174 8.77334 4.73157 9.91659C4.43691 10.4266 4.20882 10.8218 4.03882 11.1533"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                    Paramètres
                  </Link>
                  <Link
                    to="/support"
                    style={{
                      padding: "8px 16px",
                      color: "black",
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontSize: "14px",
                    }}
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    <svg width="20" height="20" viewBox="0 0 34 34" fill="none">
                      <path
                        d="M16.15 1.44511C9.37833 1.88428 4.25 7.82011 4.25 14.6059V24.0834C4.25 26.4351 6.14833 28.3334 8.5 28.3334H9.91667C11.475 28.3334 12.75 27.0584 12.75 25.5001V19.8334C12.75 18.2751 11.475 17.0001 9.91667 17.0001H7.08333V14.5776C7.08333 9.13761 11.2767 4.40594 16.7025 4.25011C18.0296 4.21028 19.3512 4.43734 20.5889 4.91784C21.8266 5.39833 22.9552 6.12247 23.9078 7.04732C24.8603 7.97216 25.6175 9.07888 26.1344 10.3018C26.6512 11.5248 26.9173 12.8391 26.9167 14.1668V17.0001H24.0833C22.525 17.0001 21.25 18.2751 21.25 19.8334V25.5001C21.25 27.0584 22.525 28.3334 24.0833 28.3334H26.9167V29.7501H18.4167C17.6375 29.7501 17 30.3876 17 31.1668C17 31.9459 17.6375 32.5834 18.4167 32.5834H25.5C27.8517 32.5834 29.75 30.6851 29.75 28.3334V14.1668C29.75 6.84261 23.5733 0.963442 16.15 1.44511Z"
                        fill="black"
                      />
                    </svg>
                    Support
                  </Link>

                  <div
                    style={{
                      height: "1px",
                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                      margin: "4px 0",
                    }}
                  ></div>
                  <Link
                    to="/logout"
                    style={{
                      padding: "8px 16px",
                      color: "black",
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontSize: "14px",
                      background: "none",
                      border: "none",
                      width: "100%",
                      cursor: "pointer",
                    }}
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    <svg width="18" height="18" viewBox="0 0 28 28" fill="none">
                      <g clipPath="url(#clip0_163_2030)">
                        <path
                          d="M9 21V25C9 25.5304 9.21071 26.0391 9.58579 26.4142C9.96086 26.7893 10.4696 27 11 27H25C25.5304 27 26.0391 26.7893 26.4142 26.4142C26.7893 26.0391 27 25.5304 27 25V3C27 2.46957 26.7893 1.96086 26.4142 1.58579C26.0391 1.21071 25.5304 1 25 1H11C10.4696 1 9.96086 1.21071 9.58579 1.58579C9.21071 1.96086 9 2.46957 9 3V7M15 14H1M1 14L5 10M1 14L5 18"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_163_2030">
                          <rect
                            width="28"
                            height="28"
                            fill="black"
                            transform="matrix(-1 0 0 1 28 0)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Se déconnecter
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="bottom-nav">
        <Link
          to="/home"
          className={`nav-item ${
            activeItem === "/home" ||
            (activeItem && /^\/articles\/[a-zA-Z0-9]+$/.test(activeItem)) ||
            (activeItem && /^\/articles\/[a-zA-Z0-9]+\/edit$/.test(activeItem))
              ? "active"
              : ""
          }`}
        >
          <i className="bi bi-house-door-fill"></i>
          <span>Accueil</span>
        </Link>
        <Link
          to="/articles"
          className={`nav-item ${
            activeItem === "/articles" ||
            activeItem === "/message" ||
            activeItem === "/articles/categories/add"
              ? "active"
              : ""
          }`}
        >
          <i className="bi bi-search"></i>
          <span>Articles</span>
        </Link>
        <Link
          to="/magasin"
          className={`nav-item ${
            activeItem === "/magasin" ||
            activeItem === "/magasin/add" ||
            (activeItem &&
              activeItem.startsWith("/magasin/") &&
              activeItem.endsWith("/edit"))
              ? "active"
              : ""
          }`}
        >
          <i className="bi bi-shop"></i>
          <span>Magasins</span>
        </Link>
        <Link
          to="/historiques"
          className={`nav-item ${
            activeItem === "/historiques" ? "active" : ""
          }`}
        >
          <i className="bi bi-clock"></i>
          <span>Suivi</span>
        </Link>
        <Link
          to="/notification"
          className={`nav-item ${
            activeItem === "/notification" ? "active" : ""
          }`}
        >
          <i className="bi bi-bell"></i>
          {stateNotification.Notifications.length > 0 ? (
            <span>
              Notification
              <span
                style={{
                  marginLeft: "1%",
                  backgroundColor: "#007bff",
                  color: "white",
                  borderRadius: "50px",
                  fontFamily: "lato",
                  fontSize: "0.5rem",
                  padding: "0.5% 4.2%",
                }}
              >
                {stateNotification.Notifications.length}
              </span>
            </span>
          ) : (
            <span>Notification</span>
          )}
        </Link>
      </div>
    </>
  );
}
